import React, { useRef, useState } from "react";

import  {
  DELETE_CLIENT,
  VIEW_CLIENT_LIST,
  LOGIN_USER
} from "../../../src/constants";

// reactstrap components
import {
  Badge,
  Button,
  Card,
  CardBody,
  Input,
  Table,
  Row,
  Col
} from "reactstrap";

import axios, { Axios } from "axios";
import NotificationAlert from "react-notification-alert";

import logo from "../../assets/img/logo.png";
import LoadingScreen from "react-loading-screen";
import ResponsivePagination from "react-responsive-pagination";
import "react-responsive-pagination/themes/classic.css";
import {useHistory} from "react-router-dom";
import ReactBSAlert from "react-bootstrap-sweetalert";





const CientList = () => {
  const userObj = localStorage.getItem("user");
  const user = JSON.parse(userObj);
  const [clientList, setClientList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
 // const [isActive, setIsActive] = React.useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const notificationAlertRef = useRef(null);
  const [filterList, setFilterLst] = useState([]);
  const [alert, setAlert] = React.useState(null);
  const navigate = useHistory();

  React.useEffect(() => {

    getClientList(1);
  
  }, []);

  const getClientList = async (pageNo) => {

    setCurrentPage(pageNo);

    await axios
      .get(VIEW_CLIENT_LIST + "?page=" + pageNo+"&user="+user?.client)
      .then((res) => {
        setClientList(res.data);
        setIsLoading(false);
        setFilterLst(res.data);
      })
      .catch((err) => console.log(err));
  };

  const confirmdelete = (id) =>{
    setAlert(<ReactBSAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title="Are you sure?"
        onConfirm={() => deleteClient(id)}
        onCancel={() => setAlert(null)}
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="danger"
        confirmBtnText="Yes, Delete"
        cancelBtnText="Cancel"
        showCancel
        btnSize=""
      >
          You want to remove client ?
      </ReactBSAlert>
      );
  }

  const deleteClient = (cid) => {
    let options = {};
    setIsLoading(true)
    axios
      .post(DELETE_CLIENT, { id:cid})
      .then((res) => {
        if(res.status==200){
          setAlert(false)
        options = {
          place: "tr",
          message: "Deleted Successfully",
          type: "success",

          autoDismiss: 2,
        };
        notificationAlertRef.current.notificationAlert(options);
        getClientList(1);
      }
      })
      .catch((e) => {
        options = {
          place: "tr",
          message: "Unable to Deleted",
          type: "warning",

          autoDismiss: 2,
        };
        notificationAlertRef.current.notificationAlert(options);
      });
  };

  const confirmlogin = (item) =>{
    setAlert(<ReactBSAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title="Are you sure?"
        onConfirm={() => login(item)}
        onCancel={() => setAlert(null)}
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="danger"
        confirmBtnText="Yes, Login"
        cancelBtnText="Cancel"
        showCancel
        btnSize=""
      >
          You want to login client ?
      </ReactBSAlert>
      );
  }

  const filterData = (e) => {
    let filter = e.target.value;
    let filterdata = filterList?.data.filter((item, index) => {
      return (
        item.company_name.toString().toLowerCase().includes(filter.toLowerCase()) ||
        item.company_email.toString().toLowerCase().includes(filter.toLowerCase()) ||
        item.company_mobile.toLowerCase().includes(filter.toLowerCase())
      );
    });
    setClientList({
      data: filterdata,
      num_of_pages: filterList.num_of_pages,
    });
  };

  const login=(item)=>{
  
    
    setIsLoading(true)
    let payload = {
      method: "POST",
      body: JSON.stringify({
        username: item.username,
        password: item.password,
       firebaseclienttoken:"",
        barertoken:""
      }),

      // Adding headers to the request
      headers: {
        "Content-type": "application/json;",
      },
    };
    loginApi(payload,item)
  }
  async function loginApi(payload,item){
    await fetch(LOGIN_USER, payload)
    .then((res) => res.json())
    .then((e) => {
      setIsLoading(false)
      if (e.status == 200) {
        localStorage.clear();
        loginUser(e,item)
     //   requestPermission()
      
      }  
      if(e.loginstatus ==1){
       // alreadyLogediin(e);
      
      } else {
        
        let options = {};
        options = {
          place: "tr",
          message: e.message,
          type: "warning",
          autoDismiss: 3,
        };
        notificationAlertRef.current.notificationAlert(options);
        //
            
       }
    })
    .catch((err) => {
      setIsLoading(false)
      let options = {};
      options = {
        place: "tr",
        message: err.toString(),
        type: "warning",
  
        autoDismiss: 3,
      };
      notificationAlertRef.current.notificationAlert(options);
  
      return {}; //(or [], or an empty return, or any return at all)
    }).finally(()=>{
      setIsLoading(false)
    })

  }

  const loginUser=(e,item)=>{
    
     
    localStorage.setItem("user", JSON.stringify(e));
    localStorage.setItem("menus", JSON.stringify(e.menus));
    localStorage.setItem("token", JSON.stringify(e.token));
    localStorage.setItem("username", item?.username);
    localStorage.setItem("password", item?.password);
   

    let options = {};
    options = {
      place: "tr",
      message: "You have successfully Login",
      type: "success",

      autoDismiss: 3,
    };

    notificationAlertRef.current.notificationAlert(options);
   if(e?.role=="Agent"){
    setTimeout(() => {
      window.location.href = "/admin/agent/liveChat";
    }, 1000);
  }
  else{
    window.location.href = "/admin";
    // setTimeout(() => {
    //   window.location.href = "/admin";
    // }, 1000);
  }
   
  }
 
  return (
    <>
      <LoadingScreen
        children=""
        loading={isLoading}
        bgColor="rgba(0,0,0,0.7)"
        spinnerColor="#9ee5f8"
        textColor="#676767"
        logoSrc={logo}
        text="Loading..."
      ></LoadingScreen>
       {alert}
      <div className="content pd-0 ">
        <Row className="Roles">
          <Card class="mb-0">
            <CardBody className="">
              <NotificationAlert ref={notificationAlertRef} />
              <Col sm="12">
                <Row>
                  <Col sm="9">
                  <h4 className=" add-content"  onClick={()=>navigate.push('/admin/client/createclient')}>
                      <Button className="btn btn-icon btn-link-add btn-sm mr-2" >
                        {/* <i className="tim-icons icon-simple-add"></i> */}
                        <i class="fa fa-plus" aria-hidden="true"></i> </Button> Add Client  </h4>
                  </Col>
                  {/* <Col sm="3" className="pull-right">
                    <Input
                      label="Search"
                      type="text"
                      onChange={(e) => filterData(e)}
                    />
                  </Col> */}
                </Row>
              </Col>
              <Col sm="12 " style={{"overflow-y":"scroll", "height": "65vh"}}>
                <Row className="">
                  <Table responsive striped className="">
                    <thead>
                      <tr>
                        <th>S.no</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Phone No</th>
                        <th>Status</th>
                        <th>Actions</th>
                      </tr>
                    </thead>

                    <tbody>
                      {clientList?.data?.map((item, index) => {
                        return (
                          <React.Fragment key={index}>
                            <tr>
                            <td>{++index}</td>
                              <td>{item.company_name}</td>
                              <td>{item.company_email}</td>
                              <td>{item.company_mobile}</td>
                              <td>
                                {item.status == 0 ? (
                                  <Badge
                                    className="badge badge-warning"
                                    color="success"
                                  >
                                    Active
                                  </Badge>
                                ) : (
                                  <span className="badge badge-warning">
                                    In-active
                                  </span>
                                )}
                              </td>
                              <td>
                                <a to="" className="text-info mr-2">
                                  <i
                                    className="tim-icons icon-pencil"
                                
                                      onClick={()=>navigate.push("/admin/client/createclient",{id:item.id})
                                     
                                    }
                                  ></i>
                                </a>
                                <a to="" className="text-warning ml-2">
                                  <i
                                    className="tim-icons icon-trash-simple"
                                    onClick={() => confirmdelete(item.id)}
                                  ></i>
                                </a>
                                {
                                 (item?.userstatus==0&&item?.dstatus==0&&item?.username&&item.password)&&
                                 <a to="" className="text-info ml-2">
                                  <i
                                    className="tim-icons icon-lock-circle"
                                    onClick={() => confirmlogin(item)}
                                  ></i>
                                </a>
                                }
                              </td>
                            </tr>
                          </React.Fragment>
                        );
                      })}
                     
                      {
                        clientList?.data?.length== 0 && (
                          <tr>
                            <td colSpan={6}>No Records Found</td>
                          </tr>
                        )
                      }
                    </tbody>
                  </Table>
                </Row>
              </Col>
            </CardBody>
            {clientList?.num_of_pages > 0 && (
              <div style={{ marginLeft: "auto", padding: "8px" }}>
                <ResponsivePagination
                  current={currentPage}
                  total={clientList?.num_of_pages}
                  onPageChange={(newPage) => {
                    getClientList(newPage);
                  }}
                />
              </div>
            )}
          </Card>

          
        </Row>
      </div>
    </>
  );
};

export default CientList;
